module.exports = __webpack_public_path__ + "img/reports_analytics.261fd20c.png";